import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";
import arrowIcon from "../../images/down-chiv.svg";


export default /*#__PURE__*/_defineComponent({
  props: {
    label: null
  },
  emits: ["click"],
  setup(__props: any, { expose }: { emit: ({
  (e: "click", event: MouseEvent): void;
}), expose: any, slots: any, attrs: any }) {





const button = ref<HTMLButtonElement | null>(null);
expose({ button });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    ref_key: "button",
    ref: button,
    class: "view-button",
    type: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event)))
  }, [
    _createVNode(SvgIcon, {
      local: "",
      class: "chevron",
      src: _unref(arrowIcon)
    }, null, 8, ["src"]),
    _createElementVNode("span", null, _toDisplayString(__props.label), 1)
  ], 512))
}
}

})